import type { DlsgPolicy } from '@repo/api-gw-sdk';

import type { Step } from '@/components/wizard/Step';

import { StorageGatewayEditStep } from './storageGatewayEditStep';

export type StorageGatewayWizardState = DlsgPolicy;

export const StorageGatewayWizardFlow: Step<StorageGatewayWizardState> = {
  name: 'Storage Gateway Edit',
  Component: StorageGatewayEditStep,
};
